// Deployment Configuration
// Update these settings based on your deployment environment

export const DEPLOYMENT_CONFIG = {
  // Supported deployment paths (subdirectories)
  deploymentPaths: [
    '/auto-ai',
    '/jj-autoservice', 
    '/training-app',
    '/app',
    '/my-app',
    '/client'
  ],
  
  // Production domains and their API endpoints
  productionDomains: {
    'soletechs.net': 'https://ringringcloser.com/api/api',
    'yourdomain.com': 'https://yourdomain.com/api',
    'app.yourdomain.com': 'https://app.yourdomain.com/api',
    'training.yourdomain.com': 'https://training.yourdomain.com/api',
    'localhost': 'http://localhost:5000'
  },
  
  // Default API URL for development
  defaultApiUrl: 'http://localhost:5000',
  
  // Environment detection
  isProduction: () => {
    return window.location.hostname !== 'localhost' && 
           window.location.hostname !== '127.0.0.1';
  },
  
  // Get current deployment path
  getCurrentPath: () => {
    const path = window.location.pathname;
    
    for (const deploymentPath of DEPLOYMENT_CONFIG.deploymentPaths) {
      if (path.includes(deploymentPath)) {
        return deploymentPath;
      }
    }
    
    return ''; // Root deployment
  },
  
  // Get API base URL
  getApiBaseUrl: () => {
    const hostname = window.location.hostname;
    
    // If localhost, use local API
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      console.log('[API Config] Using localhost API URL:', DEPLOYMENT_CONFIG.defaultApiUrl);
      return DEPLOYMENT_CONFIG.defaultApiUrl;
    }
    
    // Check if we have a specific configuration for this domain
    if (DEPLOYMENT_CONFIG.productionDomains[hostname]) {
      const apiUrl = DEPLOYMENT_CONFIG.productionDomains[hostname];
      console.log('[API Config] Using domain-specific API URL:', {
        hostname,
        apiUrl
      });
      return apiUrl;
    }
    
    // If not localhost and no specific config, use production API for soletechs.net domain
    // This handles cases like www.soletechs.net, or any subdomain
    if (hostname.includes('ringringcloser.com')) {
      const apiUrl = 'https://ringringcloser.com/api';
      console.log('[API Config] Using production API URL for soletechs.net domain:', {
        hostname,
        apiUrl
      });
      return apiUrl;
    }
    
    // Use environment variable if available
    if (process.env.REACT_APP_API_BASE_URL) {
      console.log('[API Config] Using environment variable API URL:', process.env.REACT_APP_API_BASE_URL);
      return process.env.REACT_APP_API_BASE_URL;
    }
    
    // For any other production domain, use the production API
    const apiUrl = 'https://ringringcloser.com/api';
    console.log('[API Config] Using production API URL (fallback):', {
      hostname,
      apiUrl
    });
    return apiUrl;
  }
};

export default DEPLOYMENT_CONFIG;
